module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/heading_banner_purple-48fa8b767e9db48163e13c8aba0e4e87.png";